/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'myprofile-signup-ui-layout-success',
  templateUrl: './layout-success.component.html',
  styleUrls: ['./layout-success.component.scss'],
  host: { class: 'flex-1' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LayoutSuccessComponent {}
